import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";
import {LoanNotes} from "@app/models/loan-notes";
import { CollateralNotes } from '@app/models/collateral-notes';

@Injectable({
    providedIn: 'root'
})
export class CollateralNotesService extends BaseRestService {

    readonly COLLATERAL_NOTES_URL: string = environment.collateralUri + '/collateral-notes';

    getList(pageParams: any): Observable<any> {
        const options = {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams)
        }
        return this.httpClient.get(this.COLLATERAL_NOTES_URL, options);
    }
    
    getCollateralById(id): Observable<any> {
        const options = {
            headers: this.headers
        }
        return this.httpClient.get(this.COLLATERAL_NOTES_URL + '/' + id, options);
    }
    
    create(data: LoanNotes): Observable<any> {
        return this.httpClient.post(this.COLLATERAL_NOTES_URL, JSON.stringify(data),
            { headers: this.headers });
    }
    
    update(accountType: LoanNotes): Observable<any> {
        return this.httpClient.put(this.COLLATERAL_NOTES_URL + '/' + accountType.id, JSON.stringify(accountType),
            { headers: this.headers });
    }
    
    delete(id: string): Observable<any> {
        return this.httpClient.delete(this.COLLATERAL_NOTES_URL + "/" + id,
            { headers: this.headers });
    }
    
    findCollateralNoteParents(collateralNote: CollateralNotes, collateralNotes: Array<CollateralNotes>) {
        let items = [];
        if (collateralNote) {
          items.push(collateralNote);
          if (collateralNotes && collateralNotes.length > 0) {
            var parentItem = this.findCollateralNoteById(collateralNote.parentId, collateralNotes);
            if (parentItem) {
                items = items.concat(this.findCollateralNoteParents(parentItem, collateralNotes));
            }
          }
        }
        return items;
    }

    findCollateralNoteById(id: string, items: Array<CollateralNotes>) {
        if (id) {
          if (items && items.length > 0) {
            var item = items.find((p) => p.id == id);
            if (item) {
              return item;
            }

            for (var i = 0; i < items.length; i++) {
              var item = this.findCollateralNoteById(id, items[i].subCollateralNotes);
              if (item) {
                return item;
              }
            }
          }
        }
        return undefined;
    }

}